<template>
  <v-card class="pa-5 elevation-hb">
    <v-row>
      <v-col>
        <h2 class="mb-5">Bem vindo ao Hubble</h2>
      </v-col>
      <v-col class="text-right">
        <h2 class="my-5">{{ infoMessage }}</h2>
      </v-col>
    </v-row>
    <v-divider class="my-2"></v-divider>
    <div v-if="loading" class="text-center pa-8">
      <v-progress-circular :size="100" :width="10" color="blue" indeterminate></v-progress-circular>
    </div>

    <v-scroll-y-transition>
      <div v-if="orders.length > 0">
        <v-row align-items="stretch">
          <v-col v-for="(item, i) in totals" :key="i">
            <DashboardCard2
              :quantity="item.quantity"
              :title="getStatusSeller(item.text)"
              :value="item.value"
              :color="getColor(item.text)"
              size="30px"
            />
          </v-col>
        </v-row>
      </div>
    </v-scroll-y-transition>

    <v-scroll-y-transition>
      <div v-if="orders.length > 0">
        <v-divider class="my-2"></v-divider>
        <v-row>
          <v-col cols="4">
            <h3>Vendas por dia</h3>
            <GChart type="AreaChart" :data="totalsDia" :options="options" />
          </v-col>
          <v-col v-if="sellers.length > 1" cols="4">
            <h3>Vendas por Seller</h3>
            <GChart type="ColumnChart" :data="totalsSellers" :options="options" />
          </v-col>
          <v-col cols="4">
            <h3>Satus de Vendas</h3>
            <GChart type="PieChart" :data="pieChartData" :options="options" />
          </v-col>
        </v-row>
      </div>
    </v-scroll-y-transition>
  </v-card>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { getColor, getStatusSeller } from '@/plugins/generic.js'
import DashboardCard2 from '@/components/DashboardCard2'
import { GChart } from 'vue-google-charts'

export default {
  components: {
    DashboardCard2,
    GChart,
  },
  data: () => ({
    date: {},
    dataInput: false,
    dateCount: [],
    disabled: true,
    infoMessage: '',
    infoRow: '',
    loading: false,
    loadingDatas: false,
    menu1: null,
    menu2: null,
    orders: [],
    options: { height: 300 },
    pieChartData: [['Status', 'Quantidade']],
    sellers: [],
    sellerFilter: [],
    totals: [
      { text: 1, quantity: 0, value: 0, color: '' },
      { text: 2, quantity: 0, value: 0, color: '' },
      { text: 3, quantity: 0, value: 0, color: '' },
      { text: 4, quantity: 0, value: 0, color: '' },
      { text: 5, quantity: 0, value: 0, color: '' },
      { text: 6, quantity: 0, value: 0, color: '' },
      { text: 7, quantity: 0, value: 0, color: '' },
      { text: 8, quantity: 0, value: 0, color: '' },
      { text: 9, quantity: 0, value: 0, color: '' },
    ],
    totalsSellers: [['Seller', 'Vendas', 'Valor', { role: 'style' }]],
    totalsDia: [['Data', 'Vendas']],
    color: [
      '#E53935',
      '#C2185B',
      '#6A1B9A',
      '#512DA8',
      '#303F9F',
      '#1976D2',
      '#0277BD',
      '#00838F',
      '#00695C',
      '#388E3C',
      '#558B2F',
      '#9E9D24',
      '#F9A825',
      '#F4511E',
      '#546E7A',
    ],
  }),
  methods: {
    getColor,
    getStatusSeller,
    loadOrders() {
      this.loading = true
      const url = `${baseApiUrl}/order`
      axios
        .get(url)
        .then((res) => {
          this.orders = res.data
          this.loading = false
          this.calculateTotals()
        })
        .catch(showError)
    },
    loadOrdersByDate() {
      if (this.date.start != null && this.date.end != null) {
        this.orders = []
        this.loading = true
        const url = `${baseApiUrl}/order`
        axios
          .post(url, this.date)
          .then((res) => {
            this.orders = res.data
            this.infoMessage = `${this.date.start} à ${this.date.end}.`
            this.loadDatas = true
            this.loading = false
            this.calculateTotals()
          })
          .catch(showError)
      }
    },
    loadOrdersByPeriod(period) {
      this.period = period
      this.loading = true
      this.orders = []
      const url = `${baseApiUrl}/order/period`
      axios
        .post(url, { period })
        .then((res) => {
          this.infoMessage = `Últimos ${period} dias`
          this.orders = res.data
          this.loadDatas = true
          this.loading = false
          this.calculateTotals()
        })
        .catch(showError)
    },
    loadSellers() {
      this.loading = true
      const url = `${baseApiUrl}/seller`
      axios
        .get(url)
        .then((res) => {
          this.sellers = res.data
          this.loading = false
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    calculateTotals() {
      this.sellers.forEach((seller, i) => {
        this.sellers[i].quantity = 0
      })
      this.dateCount = []
      this.totals = [
        { text: 1, quantity: 0, value: 0, color: '' },
        { text: 2, quantity: 0, value: 0, color: '' },
        { text: 3, quantity: 0, value: 0, color: '' },
        { text: 4, quantity: 0, value: 0, color: '' },
        { text: 5, quantity: 0, value: 0, color: '' },
        { text: 6, quantity: 0, value: 0, color: '' },
        { text: 7, quantity: 0, value: 0, color: '' },
        { text: 8, quantity: 0, value: 0, color: '' },
        { text: 9, quantity: 0, value: 0, color: '' },
      ]
      this.orders.forEach((element) => {
        if (this.sellerFilter.includes(element.sellerId) || this.sellerFilter.length == 0) {
          this.totals[element.orderSellerStatus - 1].quantity++
          this.totals[element.orderSellerStatus - 1].value += element.orderValue
          this.sellers.forEach((seller, i) => {
            if (element.sellerId == seller.sellerId) {
              if (this.sellers[i].quantity) {
                this.sellers[i].quantity++
              } else {
                this.sellers[i].quantity = 1
              }
            }
          })

          let date = element.orderCreationDate.substring(0, 10)

          let hasDate = false
          this.dateCount.forEach((element, i) => {
            if (element.date == date) {
              hasDate = true
              this.dateCount[i].count++
              this.dateCount[i].value += element.orderValue
            }
          })
          if (hasDate == false) {
            this.dateCount.push({
              date: date,
              count: 1,
              value: element.orderValue,
            })
          }
        }
      })
      this.totals.splice(0, 1)
      this.totals.splice(1, 1)
      this.createGoogleChartsData()
    },
    createGoogleChartsData() {
      this.pieChartData = [['Status', 'Quantidade']]
      this.totalsSellers = [['Seller', 'Vendas', { role: 'style' }]]
      this.totalsDia = [['Data', 'Vendas']]
      this.dateCount.reverse()
      this.dateCount.forEach((element) => {
        this.totalsDia.push([element.date, element.count])
      })

      for (let index = 0; index < this.totals.length; index++) {
        const element = this.totals[index]
        this.pieChartData.push([getStatusSeller(element.text), element.quantity])
      }
      for (let index = 0; index < this.sellers.length; index++) {
        const element = this.sellers[index]
        if (this.sellerFilter.includes(element.sellerId) || this.sellerFilter.length == 0) {
          this.totalsSellers.push([element.sellerId, parseInt(element.quantity), this.color[index]])
        }
      }
    },
    toggleSellerFilter() {
      this.calculateTotals()
    },
  },
  created() {
    this.disabled = false
    this.loadOrdersByPeriod(7)
    this.loadSellers()
  },
}
</script>
